import { ControllerPaletteColor } from './__palette-color';

export enum ControllerToggleButtonColor {
  ToggledOffBg = ControllerPaletteColor.GrayWhite,
  ToggledOnFg = ControllerPaletteColor.Gray100,
  ToggledOnBg = ControllerPaletteColor.Ngb900,
  ToggledOffFg = ControllerPaletteColor.Gray200,
}
